import { ValidationErrorAlert, UploadErrorAlert } from "@shared/logging";

export async function logValidationError(alert: ValidationErrorAlert) {
  const url = new URL("/api/log-validation-error", import.meta.env.VITE_BACKEND_URL);

  const truncatedAlert: ValidationErrorAlert = {
    ...alert,
    errors: alert.errors.slice(0, 5),
    ...(alert.errors.length > 5 ? { truncated: true } : {}),
  };

  await fetch(url, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(truncatedAlert),
  });
}

export async function logUploadError(alert: UploadErrorAlert) {
  const url = new URL("/api/log-upload-error", import.meta.env.VITE_BACKEND_URL);

  await fetch(url, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(alert),
  });
}
